import React, { forwardRef, Fragment } from "react";
import { SnackbarContent, useSnackbar } from "notistack";
import { isValidArray } from "../Layout/Common/common";
import { ImageWithDefault } from "../Layout/Common/imageWithDefault";

let snackbarKey = null;
let products = [];

export const CartNotification = forwardRef((props, ref) => {
  const { product, type = "ADD", onCheckout } = props;
   // Debug log to check received props
  return (
    <SnackbarContent ref={ref} className="toast-body cart-toast">
      <div className="cart-item-update">
        <h6 className="text-uppercase fw-semibold">
          <i className={`fa-solid ${type === "DEC" ? "fa-trash" : "fa-check-circle"}`} />
          <span className="notification-title">{type === "DEC" ? "Item Removed" : "Item Added to Cart"}</span>
        </h6>
      </div>

      {isValidArray(product) ? (
        <div style={{ maxHeight: 400, overflow: "auto" }}>
          {product.slice(0, 3).map((item, index) => (
            <CartItem key={index} item={item} />
          ))}
          {product.length > 3 && <div className="notification-more">+{product.length - 3} more items</div>}
        </div>
      ) : (
        <CartItem item={product} />
      )}

      <div className="cart-toast-btn mt-3">
        <a href="#" className="keepshopping">
          Keep Shopping
        </a>

        {onCheckout && (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onCheckout();
            }}
            className="checkoutcart-link"
          >
            Checkout
          </a>
        )}
      </div>
    </SnackbarContent>
  );
});

const CartItem = ({ item }) => (
  <Fragment>
    <div className="cart-toast-details mt-3">
      <div className="pro-toast-details">
        <ImageWithDefault src={item.prodImage || item.image_th} alt="product" />
        <div className="pro-toast-qty">
          <span>{item.description}</span>
          <p>Code: {item.productCode || item.prod_code}</p>
          <small>Qty:{item.qty}</small>
        </div>
      </div>
      <p className="fw-bold">${item.price || item.price_inc_applied}</p>
    </div>
  </Fragment>
);
export const useShowCartNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  return (product, type = "ADD", onCheckout = null) => {
    products.push(product);
    products = products.slice(-5);

    snackbarKey = enqueueSnackbar("", {
      variant: "cart",
      product: [...products],
      type,
      onCheckout,

      onClose: () => {
        snackbarKey = null;
        products = [];
      },
    });
  };
};
